import CommonPersona from '../commons/Persona'

export default class DocumentPersona extends CommonPersona {}
